$(document).ready(function(){
  var $contactFormContent = $(".contact_form_content");

  if(localStorage.getItem("event_btn")=='yes'){
          
      if ($contactFormContent.length) {
        setTimeout(function(){
          $('html, body').animate({
              scrollTop: $contactFormContent.offset().top - 150
          },2000);
        }, 2500);
          
      } else {
          console.error("Target element not found or not visible.");
      }
      // $('html, body').animate({
      //   scrollTop: $(".contact_form_content").offset().top - 150
      // });
    localStorage.removeItem("event_btn");
  }
    
  $('.events_single_btn').click(function(){
    localStorage.setItem("event_btn", "yes");
    
    var page_url = $(this).attr('data-href');
    window.location.href = page_url; 
  })

  // ==================================================================

  
  $('.see_more_products').click(function(){
    
      $(this).parents('.serch_bar_product').find('button[type="submit"]').trigger('click');
      
  });

  // =====================================================

 
  var product_faq_time = setInterval(function () {

  var product_faq_length = $('.product_faqs div').length;
    
    if(product_faq_length > 0)
    {
        clearInterval(product_faq_time);
    }
 $('.product_faq_question').each(function() {
      const $item = $(this);
      const $answer = $item.next();
  
      $item.on('click', function() {
        
          $('.product_faq_question').not($item).removeClass('active_heading');
          $('.product_faq_question').not($item).next().removeClass('active').css('max-height', '0');
  
          $answer.toggleClass('active');
          $item.toggleClass('active_heading');
  
          if ($answer.hasClass('active')) {
              // $answer.css('max-height', $answer.prop('scrollHeight') + "px");
            $answer.css('max-height', "1500px");
          } else {
              $answer.css('max-height', '0');
          }
      });
  
      if ($answer.hasClass('active')) {
          $answer.css('max-height', $answer.prop('scrollHeight') + "px");
      }
  });
    
    
  },3000);
  

  

  
//   document.addEventListener("DOMContentLoaded", function(event) { 

//   const faqItems = document.querySelectorAll('.product_faq_question');
 
//   faqItems.forEach(item => {
    
//     const answer = item.nextElementSibling;
//     item.addEventListener('click', () => {

//       faqItems.forEach(otherItem => {
        
//         if (otherItem !== item) 
//         {
//           const otherAnswer = otherItem.nextElementSibling;

//           // const otherIcon = otherItem.querySelector('.product_faq_question');
//           otherItem.classList.remove('active_heading');
//           otherAnswer.classList.remove('active');
        
//           otherAnswer.style.maxHeight = "0";
//         }
//       });
      
//       answer.classList.toggle('active');
//       item.classList.toggle('active_heading');
//       if (answer.classList.contains('active')) 
//       {
//         answer.style.maxHeight = answer.scrollHeight + "px";
//       } 
//       else 
//       {
//         answer.style.maxHeight = "0";
//       }
//     });

//     if (answer.classList.contains('active')) 
//     {
//       answer.style.maxHeight = answer.scrollHeight + "px";
//     } 
    
//   });
// });
});